import React from 'react';
import { POINTS_CHECK_ERROR_CARD, POINTS_CHECK_ERROR_CATEGORY, POINTS_CHECK_ERROR_OTHER } from '../constants';
import { i18n } from '../utils';


const icons = {
  error: require('../assets/icons/close.svg'),
  success: require('../assets/icons/check.svg'),
  loading: require('../assets/icons/gear.svg'),
}

i18n.initialize();

function PointsCheck({
  isVerified = false,
  isChecking = false,
  availablePoints = null,
  availablePointsCheckError = null,
  pointsCheckHandler = () => {},
}) {
  i18n.changeLanguage(localStorage.getItem('productLanguage'));
  const getMessageForPointsQuery = () => {
    if (isChecking) return i18n.t('points_please_wait');
    if (availablePointsCheckError) {
      switch (availablePointsCheckError) {
        case POINTS_CHECK_ERROR_CARD:
          return i18n.t('points_complete_card');
        case POINTS_CHECK_ERROR_CATEGORY:
          return i18n.t('points_choose_loyalty_for_query');
        case POINTS_CHECK_ERROR_OTHER:
          return i18n.t('points_error_try_again');
        default:
          return i18n.t('points_error_try_again');
      }
    }

    if (!isVerified) return i18n.t('points_complete_captcha');
    if (availablePoints !== null) return availablePoints + " " + i18n.t('points_available');
    return i18n.t('points_here');
  }

  return (
    <div className="points-check">
      <div
        onClick={ isVerified ? pointsCheckHandler : null }
        className={`
          points-check__checkbox
          ${ isChecking ? 'points-check__checkbox--loading' : '' }
          ${ isVerified && availablePoints !== null ? 'points-check__checkbox--checked' : '' }
          ${ !isVerified || isChecking || availablePoints !== null ? 'points-check__checkbox--disabled' : '' }
        `}
      >
        <div className="points-check__icon">
          {
            (isVerified && (isChecking || availablePoints || availablePointsCheckError ))
              && <img src={
                isChecking
                  ? icons["loading"]
                  : !!availablePointsCheckError
                    ? icons["error"]
                    : icons["success"] } />
          }
        </div>
        <label className="points-check__label" htmlFor="pointsCheck">{ i18n.t('points_query') }</label>
      </div>
      <p className="points-check__message">{ getMessageForPointsQuery() }</p>
    </div>
  );
}

export default PointsCheck;



// WEBPACK FOOTER //
// ./client/components/PointsCheck.js